import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";

const SettingsSidebar = () => {
  const location = useLocation();
  return (
    <>
      {/* Sidebar */}

      <div className="sidebar" id="sidebar">
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <nav className="greedy">
                <ul className="list-inline-item list-unstyled links">
                  <li>
                    <Link to="/employee-dashboard">
                      <i className="la la-home" /> <span>Back to Home</span>
                    </Link>
                  </li>
                  <li className="menu-title">Settings</li>

                  {/* Organization Settings */}
                  <li className="menu-title" style={{ fontSize: '11px', color: '#888', marginTop: '10px' }}>
                    ORGANIZATION
                  </li>
                  <li
                    className={
                      location.pathname === "/company-settings"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/company-settings">
                      <i className="la la-building" />
                      <span>Company Settings</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/branches"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/branches">
                      <i className="la la-code-branch" />
                      <span>Branches</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/departments"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/departments">
                      <i className="la la-sitemap" />
                      <span>Departments</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/designations"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/designations">
                      <i className="la la-user-tie" />
                      <span>Designations</span>
                    </Link>
                  </li>

                  {/* Employee Management */}
                  <li className="menu-title" style={{ fontSize: '11px', color: '#888', marginTop: '10px' }}>
                    EMPLOYEE MANAGEMENT
                  </li>
                  <li
                    className={
                      location.pathname === "/document-types"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/document-types">
                      <i className="la la-file-text" />
                      <span>Document Types</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/banks"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/banks">
                      <i className="la la-university" />
                      <span>Banks</span>
                    </Link>
                  </li>

                  {/* Time & Attendance */}
                  <li className="menu-title" style={{ fontSize: '11px', color: '#888', marginTop: '10px' }}>
                    TIME & ATTENDANCE
                  </li>
                  <li
                    className={
                      location.pathname === "/biometric-devices"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/biometric-devices">
                      <i className="la la-fingerprint" />
                      <span>Biometric Devices</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/holidays"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/holidays">
                      <i className="la la-calendar" />
                      <span>Holidays</span>
                    </Link>
                  </li>

                  {/* Leave Management */}
                  <li className="menu-title" style={{ fontSize: '11px', color: '#888', marginTop: '10px' }}>
                    LEAVE MANAGEMENT
                  </li>
                  <li
                    className={
                      location.pathname === "/leave-type"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/leave-type">
                      <i className="la la-plane" />
                      <span>Leave Types</span>
                    </Link>
                  </li>

                  {/* Payroll */}
                  <li className="menu-title" style={{ fontSize: '11px', color: '#888', marginTop: '10px' }}>
                    PAYROLL
                  </li>
                  <li
                    className={
                      location.pathname === "/salary-settings"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/salary-settings">
                      <i className="la la-money" />
                      <span>Salary Settings</span>
                    </Link>
                  </li>

                  {/* Workflows */}
                  <li className="menu-title" style={{ fontSize: '11px', color: '#888', marginTop: '10px' }}>
                    WORKFLOWS
                  </li>
                  <li
                    className={
                      location.pathname === "/approval-setting"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/approval-setting">
                      <i className="la la-thumbs-up" />
                      <span>Approval Settings</span>
                    </Link>
                  </li>

                  {/* Access Control */}
                  <li className="menu-title" style={{ fontSize: '11px', color: '#888', marginTop: '10px' }}>
                    ACCESS CONTROL
                  </li>
                  <li
                    className={
                      location.pathname === "/roles-permissions"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/roles-permissions">
                      <i className="la la-key" />
                      <span>Roles &amp; Permissions</span>
                    </Link>
                  </li>

                  {/* System Configuration */}
                  <li className="menu-title" style={{ fontSize: '11px', color: '#888', marginTop: '10px' }}>
                    SYSTEM
                  </li>
                  <li
                    className={
                      location.pathname === "/email-settings"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/email-settings">
                      <i className="la la-at" />
                      <span>Email Settings</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/localization"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/localization">
                      <i className="la la-globe" />
                      <span>Localization</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/notifications-settings"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/notifications-settings">
                      <i className="la la-bell" />
                      <span>Notifications</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/sms-config"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/sms-config">
                      <i className="la la-comment" />
                      <span>SMS Config (Termii)</span>
                    </Link>
                  </li>

                  {/* Other Settings */}
                  <li className="menu-title" style={{ fontSize: '11px', color: '#888', marginTop: '10px' }}>
                    OTHER
                  </li>
                  <li
                    className={
                      location.pathname === "/termination-types"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/termination-types">
                      <i className="la la-ban" />
                      <span>Termination Types</span>
                    </Link>
                  </li>
                  <li
                    className={
                      location.pathname === "/performance-setting"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/performance-setting">
                      <i className="la la-chart-bar" />
                      <span>Performance Settings</span>
                    </Link>
                  </li>
                  {/* <li
                    className={
                      location.pathname === "/app/cron-setting"
                        ? "active"
                        : ""
                    }
                  >
                    <Link to="/cron-setting">
                      <i className="la la-rocket" /> <span>Cron Settings</span>
                    </Link>
                  </li> */}
                </ul>
              </nav>
            </div>
          </div>
        </Scrollbars>
      </div>

      {/* Sidebar */}
    </>
  );
};

export default SettingsSidebar;
